import type { ReactNode } from 'react';

import { LoadingIndicator } from '../loading-indicator/LoadingIndicator';
import { Widget } from '../widget/Widget';

import styles from './fullscreen-frame.module.scss';

export type FullScreenFrameProps = {
  children?: ReactNode;
  loading?: boolean;
  showLogo?: boolean;
  title?: string;
};

export function FullScreenFrame({
  title,
  loading,
  showLogo = false,
  children,
}: FullScreenFrameProps) {
  return (
    <div className={styles['root']}>
      {showLogo && <div className={styles['tenant-logo']} />}
      <div className={styles['frame']}>
        <Widget
          title={title ?? ''}
          style={{ minHeight: loading ? '9em' : 'auto' }}
        >
          {children}
          {loading && (
            <LoadingIndicator
              style={{
                position: 'absolute',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                left: '50%',
                fontSize: '2.5em',
              }}
            />
          )}
        </Widget>
      </div>
    </div>
  );
}
